export const baseURL = "https://floor.compute.center/api"

// export const baseURL = "http://192.168.137.231:5008/api"
// export const baseURL = "http://localhost:5005/api"
